import regeneratorRuntime from "/app/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, useCallback } from 'react';
import SimpleTable from '@/components/combined/SimpleTable';
import getTxService from '@/api/transactions';
import { getColumns } from '@/constants/Transaction';
import { makeTxListLink } from '@/utils/link';
import { MASTER_TABLE_PAGE_SIZE } from '@/utils/constants';
import refreshStore from '@/store/Refresh';
import { observer } from 'mobx-react-lite';
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var txService = getTxService();
function TxnListTable(props) {
    var title = props.title, shard = props.shard, className = props.className;
    var ref = useState([]), transactions = ref[0], setTransactions = ref[1];
    var ref1 = useState(false), transactionsLoading = ref1[0], setTransactionsLoading = ref1[1];
    var refresh = refreshStore.refresh;
    useEffect(function() {
        if (refresh) {
            getTransactions();
        }
    }, [
        refresh
    ]);
    useEffect(function() {
        getTransactions();
    }, [
        shard
    ]);
    var getTransactions = useCallback(_asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        var Result;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    setTransactionsLoading(true);
                    _ctx.next = 3;
                    return txService.getList({
                        limit: MASTER_TABLE_PAGE_SIZE,
                        pos: 0,
                        shardIndex: shard
                    });
                case 3:
                    Result = _ctx.sent.Result;
                    if (Result) {
                        setTransactions(Result.ListData);
                    }
                    setTransactionsLoading(false);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        shard
    ]);
    var uniqueKey = useCallback(function(row) {
        return row.TxnHash + '-' + row.Height;
    }, []);
    return(/*#__PURE__*/ _jsx(SimpleTable, {
        loading: transactionsLoading,
        title: title,
        columns: getColumns([], true),
        data: transactions,
        rowKey: uniqueKey,
        moreHref: makeTxListLink(),
        onRefresh: getTransactions,
        className: className
    }));
}
export default observer(TxnListTable);
